import type {
  LiveQuoteReloadFormRequest,
  LiveQuoteReloadFormResponse,
  LiveTradeResponse,
} from 'apiConnector/secondary-market/live/models';
import type { ClientOrRelativesRequest, ClientOrRelativesResponse } from 'apiConnector/secondary-market/shared/clients';
import type { SettlementDateResponse } from 'apiConnector/secondary-market/shared/settlement';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { ClientType } from 'state/secondaryMarket/shared/form.models';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface LiveOrderGetOrderByIdApi {
  getOrderById(orderId: string): Observable<LiveTradeResponse>;
}

export interface LiveInitFormApi {
  init(request: LiveQuoteReloadFormRequest): Observable<LiveQuoteReloadFormResponse>;
}

export interface LiveClientFormApi {
  interactClient(request: ClientOrRelativesRequest): Observable<ClientOrRelativesResponse>;
}

export interface LiveSettlementDateApi {
  getSettlementDate(
    key: BcsProductKey,
    counterpartyEliotId: string | undefined,
    clientType: ClientType | undefined,
  ): Observable<SettlementDateResponse>;
}
export function liveQuoteFormApiConnector(
  httpClient: IHttpClient,
): LiveInitFormApi & LiveClientFormApi & LiveOrderGetOrderByIdApi & LiveSettlementDateApi {
  return {
    getOrderById: (orderId: string) => {
      return httpClient
        .getJSON<LiveTradeResponse>({
          url: `api/v1/secondary-market/live-trade?orderId=${encodeURIComponent(orderId)}`,
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    init: request => {
      return httpClient
        .postJSON<LiveQuoteReloadFormResponse>({
          url: 'api/v1/secondary-market/live-trade/forms/init',
          body: request,
          tryParseErrorPayload: true,
          parseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    interactClient: request => {
      return httpClient
        .postJSON<ClientOrRelativesResponse>({
          url: 'api/v1/secondary-market/live-trade/client',
          body: request,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    getSettlementDate(key, counterpartyEliotId, clientType) {
      return httpClient
        .getJSON<SettlementDateResponse>({
          url: `api/v1/secondary-market/live-trade/settlement-date`,
          params: {
            bcsSource: key.source,
            bcsSubType: key.subType,
            bcsCode: key.code,
            counterpartyEliotId,
            clientType,
          },
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
